<template>
    <v-menu offset-y content-class="dropdown-menu" :ripple="false">
        <template v-slot:activator="{ on }">
            <v-btn color="transparent" v-on="on" depressed :ripple="false">
                <span>{{ value }}</span>
                <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
        </template>
        <v-list>
            <div
                class="item-wrapper"
                v-for="(action, index) in actions"
                :key="index"
            >
                <v-list-item
                    :to="{ name: action.routeName }"
                    @click="updateSelected(action.displayName)"
                >
                    <v-list-item-title>{{
                        action.displayName
                    }}</v-list-item-title>
                </v-list-item>
                <v-divider v-if="index < actions.length - 1"></v-divider>
            </div>
        </v-list>
    </v-menu>
</template>

<script>
import { CHECK_BALANCE, COMBINE_CARDS, MANAGE_CARDS } from '@/constatns';

export default {
    name: 'manage-card',
    data() {
        return {
            value: MANAGE_CARDS,
        };
    },
    props: {
        actions: {
            type: Array,
            required: true,
        },
    },
    methods: {
        updateSelected(value) {
            this.value = value;
            this.$emit('input', value);
        },
    },
    watch: {
        $route(to) {
            if (to.name !== 'card-combine' && to.name !== 'card-balance') {
                this.value = MANAGE_CARDS;
            } else if (to.name === 'card-combine') {
                this.value = COMBINE_CARDS;
            } else if (to.name === 'card-balance') {
                this.value = CHECK_BALANCE;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.v-menu__content {
    margin-top: 10px;
    border-radius: 2px;
    top: 50px !important;
    background-color: #ffffff;
    opacity: 0.9;
    text-transform: uppercase;
}

.item-wrapper {
    display: flex;
    flex-direction: column;
}

.v-list {
    background-color: #ffffff !important;
    opacity: 0.9;
}

.v-list-item__title {
    font-size: 13px;
    font-weight: bolder;
}

.v-btn {
    padding: 0 !important;
    color: inherit !important;
    span {
        font-size: 13px;
    }

    v-icon {
        color: inherit !important;
    }
}

@include break('lg') {
    .v-btn {
        span {
            font-size: 14px;
        }
    }
}
</style>
